import { render, staticRenderFns } from "./labels-container.vue?vue&type=template&id=79369ca2&"
import script from "./labels-container.vue?vue&type=script&lang=js&"
export * from "./labels-container.vue?vue&type=script&lang=js&"
import style0 from "./labels-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports